// extracted by mini-css-extract-plugin
export default {"quickLinks":"FooterNav_quickLinks__OB7Dm","active":"FooterNav_active__O7VM3"};